import "core-js/modules/es.error.cause.js";
import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import tableBaseMixin from '../../amui/mixins/tableBaseMixin';
import AmFeTableColumnTemplate from './AmFeTableColumnTemplate.vue';
import AmFeSlotTableColumnEdit from './AmFeSlotTableColumnEdit.vue';
let default_1 = class default_1 extends Mixins(tableBaseMixin) {
  getContent(row) {
    return this.prop ? row[this.prop] : void 0;
  }
  execButtonAction(action, scope) {
    if (!action) return;
    const func = this.rootVm[action];
    if (typeof func !== 'function') throw new Error(`AmTableColumn action [${action}] is not a function!`);
    func(scope);
  }
  execDropdownMenuAction(scope, args) {
    const action = args[0];
    this.execButtonAction(action, scope);
  }
};
default_1.componentName = 'AmFeSlotTableColumn';
__decorate([Prop(String)], default_1.prototype, "type", void 0);
__decorate([Prop(String)], default_1.prototype, "prop", void 0);
__decorate([Prop(String)], default_1.prototype, "label", void 0);
__decorate([Prop(String)], default_1.prototype, "width", void 0);
__decorate([Prop(String)], default_1.prototype, "minWidth", void 0);
__decorate([Prop(String)], default_1.prototype, "align", void 0);
__decorate([Prop(String)], default_1.prototype, "showOverflowTooltip", void 0);
__decorate([Prop(Boolean)], default_1.prototype, "columnFold", void 0);
__decorate([Prop(Boolean)], default_1.prototype, "resizable", void 0);
__decorate([Prop(String)], default_1.prototype, "fixed", void 0);
__decorate([Prop([Boolean, String])], default_1.prototype, "sortable", void 0);
__decorate([Prop([Boolean, String])], default_1.prototype, "hideColumn", void 0);
__decorate([Prop(Boolean)], default_1.prototype, "tableFold", void 0);
default_1 = __decorate([Component({
  components: {
    AmFeTableColumnTemplate,
    AmFeSlotTableColumnEdit
  },
  name: 'AmFeSlotTableColumn'
})], default_1);
export default default_1;